import {
  ChangeDetectionStrategy,
  Component,
  inject,
  InputSignal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
  DIALOG_DATA,
  DialogRef,
  IconModule,
  SimpleInputModule,
} from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { AccountWithAmountItem } from '@iw/common';
import { Account, DialogData } from '@iw/core/entities';

import { AccountItemComponent } from '../account-item';
import { UserItemComponent } from '../user-item';
import { AccountsDialogData } from './accounts-dialog.entities';
import { CurrencyItemComponent } from '../currency-item';

@Component({
  selector: 'iw-accounts-dialog',
  styleUrl: './accounts-dialog.component.scss',
  templateUrl: './accounts-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconModule,
    AccountItemComponent,
    ReactiveFormsModule,
    SimpleInputModule,
    TranslateModule,
    UserItemComponent,
    CurrencyItemComponent,
  ],
})
export class AccountsDialogComponent {
  dialogRef = inject(DialogRef);
  dialog =
    inject<DialogData<AccountsDialogComponent, AccountsDialogData>>(
      DIALOG_DATA,
    );

  accounts: InputSignal<AccountWithAmountItem[]>;

  get dialogData() {
    return this.dialog.data;
  }

  constructor() {
    this.accounts = this.dialog.data.accounts;
  }

  isItemDisabled = (acc: Account) =>
    !!this.dialogData.disabledAccountId &&
    this.dialogData.disabledAccountId === acc.id;

  selectAccount(account: Account): void {
    if (this.isItemDisabled(account)) return;

    this.dialogRef.close(account);
  }
}
